import { pathModules, placeModules } from '@platform/client';

import { publishReadinessKey } from '../authoring/readiness';

import type { PathModulesResponse } from '@platform/client';
import type { QueryClient } from '@tanstack/react-query';

/** A path's modules, each with its lessons — PATH-02. */
export const pathModulesQuery = (id: string) => ({
  queryKey: pathModulesKey(id),
  queryFn: () => pathModules({ path: { id }, throwOnError: true }),
});

export const pathModulesKey = (id: string) => ['path-modules', id];

/**
 * Everything a change to a path's modules makes stale. The Module page and the Path page
 * both write it, and a module's row carries the paths it sits in, so every collection row
 * goes — not only this path's.
 */
export const pathChanged = async (
  queries: QueryClient,
  pathId: string,
): Promise<void> => {
  await Promise.all([
    queries.invalidateQueries({ queryKey: pathModulesKey(pathId) }),
    queries.invalidateQueries({ queryKey: publishReadinessKey(pathId) }),
    queries.invalidateQueries({ queryKey: ['library'] }),
    queries.invalidateQueries({ queryKey: ['collection'] }),
  ]);
};

/** The path's whole module order, replaced — reordering and removing are both this. */
export const placePathModules = async (
  pathId: string,
  moduleIds: string[],
): Promise<void> => {
  await placeModules({
    path: { id: pathId },
    body: { moduleIds },
    throwOnError: true,
  });
};

export type PathModule = PathModulesResponse['modules'][number];
